import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Fournisseur } from '../../../../../../models/fournisseur';
import { FournisseurService } from '../../../../../../services/Fournisseur/fournisseur.service';

export function getReferenceFromAncestorRoute(route: ActivatedRoute): string | null {
    let r: ActivatedRoute | null = route;
    while (r) {
        const ref = r.snapshot.paramMap.get('reference');
        if (ref) {
            return ref;
        }
        r = r.parent;
    }
    return null;
}

/**
 * Résout l’identifiant à passer à l’API documents (`/documents/fournisseur/:fournisseur_id/...`).
 * Ce n’est pas forcément le `id` (PK) de la table fornisseurs : c’est le `fournisseur_id` métier
 * (comme sur `document.fornisseurs[0].fournisseur_id`). On charge donc toujours le fournisseur et on
 * privilégie `fournisseur_id`, avec repli sur `id` si absent.
 */
export function resolveFournisseurDbIdFromRouteParam(
    referenceParam: string | null | undefined,
    svc: FournisseurService
): Observable<number | null> {
    if (!referenceParam || !String(referenceParam).trim()) {
        return of(null);
    }
    const s = String(referenceParam).trim();
    return svc.getFournisseurById(s).pipe(
        map((f: Fournisseur | any) => mapFournisseurToDocumentsApiId(f)),
        catchError(() => of(null))
    );
}

function mapFournisseurToDocumentsApiId(f: Fournisseur | any | null | undefined): number | null {
    if (f == null) {
        return null;
    }
    const business = f.fournisseur_id;
    if (business != null && business !== '' && !Number.isNaN(Number(business))) {
        return Number(business);
    }
    if (f.id != null && !Number.isNaN(Number(f.id))) {
        return Number(f.id);
    }
    return null;
}
